const externalOrderRequestModel = {
  id: null,
  status: null,
  customerId: null,
  requestedType: null,
  eventKind: null,
  requestedStartAt: null,
  requestedEndAt: null,
  pickup: null,
  delivery: null,
  patient: null,
  contact: null,
  notes: null,
  priority: null,
  returnTransport: false,
  infectious: false,
  rejectionReason: null,
  changesRequestReason: null,
  statusHistory: [],
  createdAt: null,
  updatedAt: null,
}

const externalOrderRequestStatuses = [
  'draft',
  'submitted',
  'changes_requested',
  'accepted',
  'rejected',
  'cancelled',
]

export default {
  externalOrderRequestModel,
  externalOrderRequestStatuses,
  partnerOrderRequests: [],
  partnerOrderRequest: { ...externalOrderRequestModel },
  partnerOrderRequestsTotal: 0,
  partnerOrderRequestsLimit: 25,
  partnerOrderRequestsPage: 1,
  partnerOrderRequestStatusTotals: {
    draft: 0,
    submitted: 0,
    changes_requested: 0,
    accepted: 0,
    rejected: 0,
    cancelled: 0,
  },
  allowedCustomers: [],
  allowedOrderTypes: [],
  partnerOrderRequestInstruction: null,
  dispatcherReviewRequests: [],
  dispatcherReviewRequest: { ...externalOrderRequestModel },
  dispatcherReviewRequestsTotal: 0,
  dispatcherReviewRequestsLimit: 25,
  dispatcherReviewRequestsPage: 1,
  dispatcherReviewPendingTotal: 0,
  dispatcherReviewStatusTotals: {
    submitted: 0,
    changes_requested: 0,
    accepted: 0,
    rejected: 0,
    cancelled: 0,
  },
}
